var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageToolbar',{attrs:{"title":_vm.$tc('global.fornecedor', 2),"icon":"mdi-truck-outline","dark":""}}),_c('ListaFornecedores')],1)}
var staticRenderFns = []

export { render, staticRenderFns }